import React from 'react';
import { MessageCircle } from 'lucide-react';
import { whatsappLink } from '../mock';

export default function WhatsAppFab() {
  return (
    <a
      href={whatsappLink('Namaste Goodwishes India Tours, mujhe tour package ki jaankari chahiye')}
      target="_blank" rel="noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 text-white flex items-center justify-center shadow-2xl transition-colors"
    >
      <MessageCircle className="w-7 h-7" fill="#fff" strokeWidth={0} />
    </a>
  );
}
